import React, { Component } from "react";
import axios from "axios";
import { FormGroup, Input } from "reactstrap";

export default class Db extends Component {
  state = {
    routes: [],
    isLoading: true
  };

  componentDidMount() {
    let t = this.props.trainNO.split("/ ");

    axios
      .get("https://api.confirmtkt.com/api/trains/schedulewithdetails", {
        params: { trainNo: t[0] }
      })
      .then(response => {
        const st = response.data.Schedule.map(station => {
          return { value: station.StationCode, display: station.StationName };
        });

        console.log(st[0].value);

        this.setState({
          routes: st,
          isLoading: false
        });
      });
  }

  render() {
    // let today = new Date();
    // let dd = String(today.getDate()).padStart(2, "0");
    // let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    // let yyyy = today.getFullYear();

    // today = mm + "/" + dd + "/" + yyyy;
    // console.log(today);
    return (
      <div>
        {/* <FormGroup>
          Date of Journey
          <Input
            id="dateRequired"
            type="date"
            name="doj"
            placeholder="Journey Date"
            onChange={this.props.change1}
          />
          {this.props.errordoj !== "" ? (
            <p style={{ color: "red", fontSize: "12px" }}>
              ERROR: {this.props.errordoj}
            </p>
          ) : null}
        </FormGroup> */}

        <FormGroup>
          <Input
            type="select"
            name="select"
            defaultValue="1"
            id="exampleSelect"
            onChange={this.props.change2}
            style={{ height: 50 }}
          >
            <option value="1" disabled>
              Select Station
            </option>

            {this.state.isLoading === false && this.state.routes.length > 0 ? (
              this.state.routes.map(item => {
                return (
                  <option value={item.value} key={item.value}>
                    {item.display + "   " + item.value}
                  </option>
                );
              })
            ) : (
              <option value="" disabled>
                Loading
              </option>
            )}
          </Input>
          {this.props.errorstationCode !== "" ? (
            <p style={{ color: "red", fontSize: "12px" }}>
              ERROR: {this.props.errorstationCode}
            </p>
          ) : null}
        </FormGroup>
      </div>
    );
  }
}
